import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { MagnifyingGlass, X, Plus } from "@phosphor-icons/react";
import { errMsg, fmtBRL } from "@/lib/medicoes";

function Analitica({ tabelaId, item, tipo, onClose }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/engenharia/composicao", { params: { tabela_id: tabelaId, codigo: item.codigo, tipo } }).then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [tabelaId, item.codigo, tipo]);
  const c = d?.item;
  return (
    <div className="fixed inset-0 z-[130] bg-black/80 flex items-center justify-center p-4" onClick={onClose}>
      <div className="tce-card w-full max-w-4xl max-h-[90vh] overflow-y-auto p-6" onClick={(e) => e.stopPropagation()} data-testid="analitica-modal">
        <div className="flex justify-between gap-4">
          <div>
            <div className="uppercase-label">{d?.tabela?.fonte} · competência {d?.tabela?.competencia || "não informada"} · {d?.tabela?.regime}</div>
            <div className="font-heading text-xl mt-1"><span className="font-mono text-[#FFDF00]">{item.codigo}</span> — {item.descricao}</div>
            <div className="text-sm text-[#94A3B8] mt-1">Unidade {item.unidade} · Preço oficial {item.preco ? fmtBRL(item.preco) : "sem preço"}</div>
            <div className="text-xs text-[#94A3B8] mt-1 flex flex-wrap gap-3" data-testid="analitica-indicadores">
              {item.sem_preco && <span className="text-[#EF4444]">Sem preço na UF {d?.tabela?.uf || "CE"} — não pode ser orçado</span>}
              {item.pct_mao_obra && <span>Mão de obra: <b>{(Number(item.pct_mao_obra) * 100).toFixed(2)}%</b></span>}
              {item.preco_atribuido_sp && <span className="text-[#F59E0B]">%AS {(Number(item.pct_as) * 100).toFixed(2)}%: parte do custo usa preços de São Paulo</span>}
              {item.situacao && <span>Situação SINAPI: {item.situacao}</span>}
            </div>
          </div>
          <button onClick={onClose} data-testid="analitica-close"><X size={20} /></button>
        </div>
        {!c ? <p className="text-[#94A3B8] mt-4">Carregando…</p> : tipo === "insumo" ? <p className="mt-4 text-sm">Insumo {c.categoria ? `· ${c.categoria}` : ""}</p> : (
          <>
            <table className="w-full text-xs mt-4">
              <thead className="bg-[#1E293B] text-left"><tr>{["Tipo", "Código", "Descrição", "Un", "Coeficiente", "Preço unit.", "Custo parcial"].map((h) => <th key={h} className="px-2 py-2 uppercase-label !text-[10px]">{h}</th>)}</tr></thead>
              <tbody>
                {c.itens.map((i, k) => (
                  <tr key={k} className="border-t border-[#334155]"><td className="px-2 py-1.5">{i.tipo}</td><td className="px-2 py-1.5 font-mono">{i.codigo}</td><td className="px-2 py-1.5">{i.descricao}</td>
                    <td className="px-2 py-1.5">{i.unidade}</td><td className="px-2 py-1.5 font-mono text-right">{i.coeficiente}</td>
                    <td className="px-2 py-1.5 font-mono text-right">{i.preco_unitario ? fmtBRL(i.preco_unitario) : "—"}</td><td className="px-2 py-1.5 font-mono text-right">{i.custo_parcial ? fmtBRL(i.custo_parcial) : "—"}</td></tr>
                ))}
              </tbody>
            </table>
            {!c.itens.length && <p className="text-sm text-[#94A3B8] mt-3">Composição analítica não importada para esta tabela.</p>}
            {c.custo_calculado && <p className="text-xs mt-3" data-testid="analitica-total">Soma dos custos parciais: <b className="font-mono">{fmtBRL(c.custo_calculado)}</b> · preço oficial da tabela: <b className="font-mono">{c.preco ? fmtBRL(c.preco) : "—"}</b> (valores oficiais preservados; sem alteração)</p>}
          </>
        )}
      </div>
    </div>
  );
}

export default function Pesquisa({ tabelaId: fixa, onAdd, marcados, onToggle }) {
  const [tabelas, setTabelas] = useState([]);
  const [tabelaId, setTabelaId] = useState(fixa || "");
  const [f, setF] = useState({ q: "", tipo: "composicao", unidade: "", grupo: "", page: 1 });
  const [d, setD] = useState(null);
  const [sel, setSel] = useState(null);
  useEffect(() => {
    if (fixa) return;
    api.get("/engenharia/tabelas").then((r) => {
      const pub = r.data.items.filter((t) => t.status === "publicada");
      setTabelas(pub);
      if (pub[0]) setTabelaId(pub[0].id);
    });
  }, [fixa]);
  useEffect(() => {
    if (!tabelaId) return undefined;
    const t = setTimeout(() => api.get("/engenharia/pesquisa", { params: { tabela_id: tabelaId, ...f } }).then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e))), 300);
    return () => clearTimeout(t);
  }, [tabelaId, f]);
  const inp = "tce-input px-3 py-2.5 rounded-md text-sm";
  if (!fixa && !tabelas.length) return <p className="text-sm text-[#F59E0B]" data-testid="sem-tabelas">Nenhuma tabela oficial publicada. O administrador precisa importar as tabelas SEINFRA-CE / SINAPI-CE.</p>;
  return (
    <div className="space-y-4" data-testid="pesquisa-composicoes">
      <div className="flex flex-wrap gap-2">
        {!fixa && <select data-testid="pesq-tabela" value={tabelaId} onChange={(e) => setTabelaId(e.target.value)} className={inp}>
          {tabelas.map((t) => <option key={t.id} value={t.id}>{`${t.fonte} · ${t.competencia || "s/ competência"} · ${t.regime}${t.versao ? ` · ${t.versao}` : ""}`}</option>)}
        </select>}
        <select data-testid="pesq-tipo" value={f.tipo} onChange={(e) => setF({ ...f, tipo: e.target.value, page: 1 })} className={inp}>
          <option value="composicao">Composições / serviços</option><option value="insumo">Insumos</option>
        </select>
        <div className="relative flex-1 min-w-[220px]">
          <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#94A3B8]" />
          <input data-testid="pesq-q" value={f.q} onChange={(e) => setF({ ...f, q: e.target.value, page: 1 })} placeholder="Código, descrição ou palavras-chave…" className={`${inp} w-full pl-10`} />
        </div>
        <input data-testid="pesq-unidade" value={f.unidade} onChange={(e) => setF({ ...f, unidade: e.target.value, page: 1 })} placeholder="Unidade" className={`${inp} w-24`} />
        <input data-testid="pesq-grupo" value={f.grupo} onChange={(e) => setF({ ...f, grupo: e.target.value, page: 1 })} placeholder="Grupo/categoria" className={`${inp} w-40`} />
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead className="bg-[#1E293B] text-left"><tr>{(onToggle ? ["✓", "Código", "Descrição", "Un", "Preço", ""] : ["Código", "Descrição", "Un", "Preço", ""]).map((h) => <th key={h} className="px-3 py-2.5 uppercase-label !text-[10px]">{h}</th>)}</tr></thead>
          <tbody>
            {d?.items.map((it, i) => (
              <tr key={it.codigo} className="border-t border-[#334155] hover:bg-[#1E293B]/60" data-testid={`pesq-row-${i}`}>
                {onToggle && <td className="px-3 py-2"><input type="checkbox" data-testid={`pesq-check-${i}`} disabled={it.sem_preco} checked={!!marcados?.[`${f.tipo}:${it.codigo}`]} onChange={() => onToggle({ ...it, tipo: f.tipo })} className="accent-[#FFDF00] w-4 h-4" /></td>}
                <td className="px-3 py-2 font-mono text-[#FFDF00]">{it.codigo}</td>
                <td className="px-3 py-2"><button onClick={() => setSel(it)} className="text-left hover:underline" data-testid={`pesq-ver-${i}`}>{it.descricao}</button></td>
                <td className="px-3 py-2">{it.unidade}</td>
                <td className="px-3 py-2 font-mono text-right">{it.sem_preco ? <span className="text-[10px] px-2 py-0.5 rounded-full bg-[#EF4444]/15 text-[#EF4444] font-sans" data-testid={`pesq-sem-preco-${i}`}>sem preço no CE</span> : (it.preco ? fmtBRL(it.preco) : "—")}
                  {it.preco_atribuido_sp && <span className="ml-1 text-[10px] text-[#F59E0B] font-sans" title="Parte do custo obtida com preços de São Paulo (%AS)">%AS</span>}</td>
                <td className="px-3 py-2 text-right">{onAdd && !it.sem_preco && <button data-testid={`pesq-add-${i}`} onClick={() => onAdd({ ...it, tipo: f.tipo })} className="px-2 py-1 rounded bg-[#009C3B]/20 text-[#22C55E] flex items-center gap-1 ml-auto"><Plus size={12} /> adicionar</button>}</td>
              </tr>
            ))}
            {d && !d.items.length && <tr><td colSpan={6} className="px-3 py-6 text-center text-[#94A3B8]">Nada encontrado.</td></tr>}
          </tbody>
        </table>
      </div>
      {d && d.total > 30 && (
        <div className="flex items-center gap-3 text-xs">
          <button disabled={f.page <= 1} onClick={() => setF({ ...f, page: f.page - 1 })} className="px-3 py-1 rounded border border-[#334155] disabled:opacity-30">Anterior</button>
          <span>Página {f.page} de {Math.ceil(d.total / 30)} · {d.total} registros</span>
          <button disabled={f.page * 30 >= d.total} onClick={() => setF({ ...f, page: f.page + 1 })} className="px-3 py-1 rounded border border-[#334155] disabled:opacity-30" data-testid="pesq-next">Próxima</button>
        </div>
      )}
      {sel && <Analitica tabelaId={tabelaId} item={sel} tipo={f.tipo} onClose={() => setSel(null)} />}
    </div>
  );
}
